import { Card, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import useServiceBox from '../hooks/useServiceBox';
import ServiceBoxImage from '../images/ServiceBoxImage';
import ServiceBoxImage2 from '../images/ServiceBoxImage2';
import ServiceBoxImage3 from '../images/ServiceBoxImage3';
import ServiceBoxStyles from './ServiceBox.style';

const ServiceBox = () => {
  const { t } = useTranslation();
  const { SERVICES_DATA, currentIndex, setCurrentIndex } = useServiceBox();
  return (
    <Card className={ServiceBoxStyles.wrapper}>
      <div className={ServiceBoxStyles.imageContainer}>
        {SERVICES_DATA[currentIndex].image === SERVICES_DATA[0].image && (
          <ServiceBoxImage />
        )}
        {SERVICES_DATA[currentIndex].image === SERVICES_DATA[1].image && (
          <ServiceBoxImage2 />
        )}
        {SERVICES_DATA[currentIndex].image === SERVICES_DATA[2].image && (
          <ServiceBoxImage3 />
        )}
      </div>
      <div className={ServiceBoxStyles.textContainer}>
        <Typography variant="body2">
          {t(SERVICES_DATA[currentIndex].title)}{' '}
          {t(SERVICES_DATA[currentIndex]?.subtitle ?? '', '')}
        </Typography>
      </div>
      <div className={ServiceBoxStyles.selectorContainer}>
        {SERVICES_DATA.map((_, index) => (
          <button
            key={SERVICES_DATA[index].id}
            type="button"
            aria-label={`Select service ${index + 1}`}
            className={clsx(
              ServiceBoxStyles.dotSelector,
              currentIndex === index
                ? ServiceBoxStyles.activeDot
                : ServiceBoxStyles.inactiveDot
            )}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </Card>
  );
};

export default ServiceBox;
